import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("desc", null, "House Entrance Streamline Icon: https://streamlinehq.com", -1),
    _createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M22.868 8.947 12 .747l-10.878 8.2a1.18 1.18 0 0 0-.377.8v12.522a.98.98 0 0 0 .978.978h6.522V18a3.75 3.75 0 0 1 7.5 0v5.25h6.521a.98.98 0 0 0 .979-.978V9.747a1.18 1.18 0 0 0-.377-.8"
    }, null, -1)
  ])))
}
export default { render: render }